import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {StorageService} from '@app/services/storage.service';


@Directive({
  selector: '[isAuthenticated]',
})
export class IsAuthenticatedDirective implements OnInit, OnDestroy {

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private storageService: StorageService
  ) {
  }

  public ngOnInit() {
    if (!this.storageService.isAuthenticated()) {
      this.viewContainerRef.clear();
      return;
    }
    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }

  public ngOnDestroy(): void {
  }
}
